<div class="mobile-forgot-password">
  <div class="fp-status-spacer"></div>

  <button type="button" class="fp-back-btn" (click)="navigateBack()" aria-label="Back">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <h1>{{ 'FORGOT_PASSWORD.TITLE' | translate }}</h1>
  <p class="fp-subtitle">{{ 'FORGOT_PASSWORD.SUBTITLE' | translate }}</p>

  <div class="fp-field">
    <label for="fp-email">{{ 'FORGOT_PASSWORD.EMAIL_LABEL' | translate }}</label>
    <div class="fp-input-wrap">
      <input
        id="fp-email"
        class="fp-input"
        type="email"
        [(ngModel)]="emailValue"
        [placeholder]="'FORGOT_PASSWORD.EMAIL_PLACEHOLDER' | translate"
      />
      <button *ngIf="emailValue" type="button" class="fp-clear-btn" (click)="clearEmail()">x</button>
    </div>
    <span *ngIf="emailError" class="fp-error">{{ emailError | translate }}</span>
  </div>

  <p class="fp-alt-method">
    <span>{{ 'FORGOT_PASSWORD.USE_PHONE_INSTEAD' | translate }}</span>
    <span class="fp-alt-link fp-alt-disabled">{{ 'FORGOT_PASSWORD.PHONE' | translate }}</span>
  </p>

  <p class="fp-request-error" *ngIf="requestError">{{ requestError | translate }}</p>
  <p class="fp-success-msg" *ngIf="successMessage">{{ successMessage | translate }}</p>

  <button type="button" class="fp-continue-btn" (click)="validateAndSubmit()" [disabled]="isLoading">
    <span *ngIf="!isLoading">{{ 'FORGOT_PASSWORD.CONTINUE_BTN' | translate }}</span>
    <i *ngIf="isLoading" class="bi bi-arrow-repeat fp-spinner"></i>
  </button>

  <div class="fp-home-indicator-spacer"></div>
</div>
